import { Pipe, PipeTransform } from "@angular/core";
import { LorenUserInfo } from "../../../../../../interfaces/loren-user-info.interface";

@Pipe({
    name: "lorenUserInitials",
    standalone: false
})
export class LorenUserInitialsPipe implements PipeTransform {
  transform(userInfo: LorenUserInfo): string {
    if (userInfo) {
      if (userInfo.firstName && userInfo.lastName) {
        return `${userInfo.firstName[0]}${userInfo.lastName[0]}`.toUpperCase();
      }
    }

    return null;
  }
}
